// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import DataVaxiomInsuranceCarrierForm from './view'

export default function DataVaxiomInsuranceCarrierFormFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/DataVaxiomInsuranceCarrierForm">
      <DataVaxiomInsuranceCarrierForm {...props}>
        {children}
      </DataVaxiomInsuranceCarrierForm>
    </Flow>
  )
}
